import ChapterCategoriesAPI  from "@/services/api/exercise/api-chapter-categories"
export default {
  namespaced: true,

  state: () => ({
    items: null
  }),

  mutations: {
    set(state, items) {
      state.items = items
    }
  },

  actions: {
    async list({state, commit}, params) {
      try {
        if(params && params.cache && state.items) return state.items
        let res = await ChapterCategoriesAPI.list()
        commit('set', res)
        return res
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    },
  }
}